/* Thanks2You drukgebieden: zoekt het product op een packshot en berekent de drukzones.
   Werkt op packshots met transparante of effen achtergrond.
   Twee soorten families:
   - lijf (T-shirts, polo's, sweaters, hoodies, jassen, hemden, ...): maten in cm via de lijfbreedte,
     afstanden vanaf de schouder naast de kraag (HPS).
   - vorm (petten, mutsen, tassen, schorten): zones ten opzichte van de omtrek van het product,
     cm via een vaste breedte per familie. */
(function (g) {
  var AW = 240; /* analysebreedte in px */

  function maskVan(img) {
    var W = img.naturalWidth || img.width, H = img.naturalHeight || img.height;
    var w = AW, h = Math.round(AW * H / W);
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data;
    var hoek = [0, w - 1, (h - 1) * w, h * w - 1];
    var transp = hoek.every(function (i) { return d[i * 4 + 3] < 30; });
    var bg = [0, 0, 0];
    if (!transp) hoek.forEach(function (i) { bg[0] += d[i * 4] / 4; bg[1] += d[i * 4 + 1] / 4; bg[2] += d[i * 4 + 2] / 4; });
    var m = new Uint8Array(w * h), n = 0;
    for (var i = 0; i < w * h; i++) {
      var j = i * 4, aan;
      if (transp) aan = d[j + 3] > 100;
      else aan = d[j + 3] > 100 && Math.max(Math.abs(d[j] - bg[0]), Math.abs(d[j + 1] - bg[1]), Math.abs(d[j + 2] - bg[2])) > 14;
      if (aan) { m[i] = 1; n++; }
    }
    return { m: m, w: w, h: h, transp: transp, bg: bg, dekking: n / (w * h) };
  }

  function runs(M, y) {
    var r = [], s = -1, w = M.w, o = y * w;
    for (var x = 0; x < w; x++) {
      var a = M.m[o + x];
      if (a && s < 0) s = x;
      if (!a && s >= 0) { if (x - s > 1) r.push([s, x - 1]); s = -1; }
    }
    if (s >= 0 && w - s > 1) r.push([s, w - 1]);
    return r;
  }
  function med(a) { if (!a.length) return 0; a = a.slice().sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }

  /* geometrie in fracties van de beeldbreedte (x) en -hoogte (y) */
  function meet(img) {
    var M = maskVan(img), w = M.w, h = M.h;
    var y0 = -1, y1 = -1, x0 = w, x1 = -1, R = [];
    for (var y = 0; y < h; y++) {
      var r = runs(M, y); R.push(r);
      if (!r.length) continue;
      var bw = 0; r.forEach(function (q) { bw += q[1] - q[0]; });
      if (bw < 3) continue;
      if (y0 < 0) y0 = y; y1 = y;
      if (r[0][0] < x0) x0 = r[0][0];
      if (r[r.length - 1][1] > x1) x1 = r[r.length - 1][1];
    }
    if (y0 < 0) return null;
    var Hg = y1 - y0;
    /* middenlijn: midden van de run die het midden raakt, in het onderste deel */
    var cx0 = (x0 + x1) / 2, cs = [];
    for (y = Math.round(y0 + 0.6 * Hg); y < y0 + 0.9 * Hg; y++) {
      R[y].forEach(function (q) { if (q[0] <= cx0 && q[1] >= cx0) cs.push((q[0] + q[1]) / 2); });
    }
    var cx = cs.length ? med(cs) : cx0;
    function middenRun(y) { var r = R[y], b = null; r.forEach(function (q) { if (q[0] <= cx && q[1] >= cx) b = q; }); return b; }
    function breedte(y) { var q = middenRun(y); return q ? q[1] - q[0] : 0; }
    /* romp onderaan (zonder mouwen als die los hangen) */
    var onder = [], zoom = [];
    for (y = Math.round(y0 + 0.62 * Hg); y < y0 + 0.88 * Hg; y++) onder.push(breedte(y));
    for (y = Math.round(y0 + 0.92 * Hg); y < y0 + 0.97 * Hg; y++) zoom.push(breedte(y));
    var romp = med(onder), onderrand = med(zoom);
    /* mouwen tegen het lijf (of plat gelegd): de onderrand is dan smaller dan de romp */
    if (onderrand && onderrand < romp * 0.9) romp = onderrand;
    var bboxW = x1 - x0;
    var mouwVast = romp > 0.9 * bboxW && Hg / bboxW < 1.6;
    /* oksel: van onder naar boven, eerste rij die duidelijk breder wordt */
    var oksel = -1;
    for (y = Math.round(y0 + 0.62 * Hg); y > y0 + 0.12 * Hg; y--) {
      if (breedte(y) > romp * 1.12) { oksel = y; break; }
    }
    var borst = romp;
    if (oksel > 0) {
      var bb = [];
      for (y = oksel + Math.round(0.03 * Hg); y < oksel + 0.12 * Hg; y++) bb.push(breedte(y));
      borst = Math.min(med(bb) || romp, romp * 1.1);
    }
    /* bovenkant schouder naast de kraag (HPS), buiten een eventuele paspophals */
    function top(xx) { xx = Math.round(xx); if (xx < 0 || xx >= w) return h; for (var yy = y0; yy < y1; yy++) if (M.m[yy * w + xx]) return yy; return h; }
    var sch = [];
    for (var f = 0.26; f <= 0.34; f += 0.02) { sch.push(top(cx - f * borst)); sch.push(top(cx + f * borst)); }
    var hps = med(sch);
    /* capuchon op of rechtop: de schouder begint pas verder naar buiten. Ligt de bovenkant op 0,40 x de
       lijfbreedte meer dan ±4 cm lager dan het gemeten HPS, dan meten we op de schouder (0,44-0,48)
       en rekenen ±2 cm schouderhelling terug. */
    var kap = false;
    var t40 = (top(cx - 0.40 * borst) + top(cx + 0.40 * borst)) / 2;
    if (borst > 0 && t40 - hps > 0.11 * borst) {
      var s2 = [];
      for (f = 0.44; f <= 0.48; f += 0.02) { s2.push(top(cx - f * borst)); s2.push(top(cx + f * borst)); }
      var t46 = med(s2);
      if (t46 < y1 && t46 - 0.054 * borst > hps) { hps = t46 - 0.054 * borst; kap = true; }
    }
    var kraag = h;
    for (var xx = Math.round(cx - 0.18 * borst); xx <= cx + 0.18 * borst; xx++) kraag = Math.min(kraag, top(xx));

    /* ---- vormgegevens (petten, mutsen, tassen, schorten) ---- */
    function uiterst(y) { var r = R[y]; return r && r.length ? [r[0][0], r[r.length - 1][1]] : null; }
    function ext(y) { var u = uiterst(Math.round(y)); return u ? u[1] - u[0] : 0; }
    var maxW = 0;
    for (y = y0; y <= y1; y++) maxW = Math.max(maxW, ext(y));
    /* bovenkant van het lijf: eerste rij die minstens 70% van de grootste breedte haalt (zonder hengsels of halslus) */
    var lijfTop = y0, borstTop = y0;
    for (y = y0; y <= y1; y++) if (ext(y) >= 0.7 * maxW) { lijfTop = y; break; }
    for (y = y0; y <= y1; y++) if (ext(y) >= 0.3 * maxW) { borstTop = y; break; }
    /* symmetrie rond het midden van de omtrek (vooraanzicht = hoog) */
    var mc = (x0 + x1) / 2, tot = 0, sp = 0;
    for (y = y0; y <= y1; y += 2) for (var xq = x0; xq <= x1; xq += 2) {
      if (!M.m[y * w + xq]) continue;
      tot++;
      var xm = Math.round(2 * mc - xq);
      if (xm >= 0 && xm < w && M.m[y * w + xm]) sp++;
    }
    var sym = tot ? sp / tot : 1;
    /* onderste 30%: hoe ver blijft de vorm links en rechts van de omtrek weg (de klep van een pet in
       zijaanzicht loopt tot tegen de rand, de achterkant niet) */
    var oL = w, oR = -1;
    for (y = Math.round(y0 + 0.7 * Hg); y <= y1; y++) { var u = uiterst(y); if (u) { oL = Math.min(oL, u[0]); oR = Math.max(oR, u[1]); } }
    var gapL = bboxW ? (oL - x0) / bboxW : 0, gapR = bboxW ? (x1 - oR) / bboxW : 0;
    return {
      w: w, h: h, transp: M.transp, dekking: M.dekking,
      x0: x0 / w, x1: x1 / w, y0: y0 / h, y1: y1 / h,
      cx: cx / w, borst: borst / w, romp: romp / w, oksel: oksel > 0 ? oksel / h : null,
      hps: hps / h, kraag: kraag / h, mouwVast: mouwVast, ratio: h / w, kap: kap,
      maxW: maxW / w, lijfTop: lijfTop / h, borstTop: borstTop / h, sym: sym, gapL: gapL, gapR: gapR,
      bW12: ext(y0 + 0.12 * Hg) / w, bW70: ext(y0 + 0.7 * Hg) / w
    };
  }

  /* goed genoeg gemeten? (wit op witte achtergrond lukt bv. niet) */
  function goed(geo, fam) {
    if (!geo) return false;
    if (fam && fam.soort === 'vorm') return geo.dekking > 0.03 && geo.dekking < 0.95 && geo.maxW > 0.1;
    return geo.borst > 0.15 && geo.borst < 0.97 && geo.dekking > 0.06 && geo.dekking < 0.92 && geo.hps < 0.5;
  }

  /* Zichtbare lijfbreedte in cm op een 3D-packshot (maat M). Het lijf is rond, dus in beeld
     ongeveer 0,72 x de platte borstbreedte (heren 52 cm plat = 37 cm in beeld).
     f = schaal van de afstanden (kleiner lijf = logo's dichter bij de kraag). */
  var GROEP = {
    heren: { lijf: 37, f: 1, naam: 'Heren / unisex' },
    dames: { lijf: 33, f: 0.92, naam: 'Dames' },
    kind: { lijf: 29, f: 0.78, naam: 'Kinderen' },
    baby: { lijf: 22, f: 0.6, naam: 'Baby' }
  };
  function groep(titel) {
    var t = (titel || '').toLowerCase();
    if (/baby/.test(t)) return 'baby';
    if (/kind|kids|jongen|meisje|junior/.test(t)) return 'kind';
    if (/dames|vrouw|women|lady/.test(t)) return 'dames';
    return 'heren';
  }

  /* formaten, zelfde indeling als de bedrukkingsprijzen: [max breedte cm, max hoogte cm] */
  var MAAT = { P: [6, 6], K: [9, 9], M: [18, 18], G: [28, 30] };
  /* posities op het lijf: [kant, dx cm, dy cm vanaf de schouder naast de kraag, anker (m = midden, b = bovenkant)]
     afstanden voor een heren maat M; bij dames/kinderen geschaald met f */
  var POS = {
    'Borst links': ['voor', 9.5, 19.5, 'm'],
    'Borst rechts': ['voor', -9.5, 19.5, 'm'],
    'Borst midden': ['voor', 0, 15, 'b'],
    'Rug': ['achter', 0, 9, 'b'],
    /* vormfamilies: de plaats volgt uit de vorm, zie vormZone */
    'Voorkant': ['voor', 0, 0, 'm'],
    'Achterkant': ['achter', 0, 0, 'm'],
    'Linksonder': ['voor', 0, 0, 'm'],
    'Rechtsonder': ['voor', 0, 0, 'm'],
    'Bovenaan': ['voor', 0, 0, 'm'],
    'Onderaan': ['voor', 0, 0, 'm']
  };
  /* met capuchon ligt de kap op de rug: ruglogo lager */
  var RUG_KAP = 25;
  /* standaard voor T-shirts (zoals in het personalisatieblok) */
  var STANDAARD = [['Borst links', 'K'], ['Borst rechts', 'K'], ['Borst midden', 'K'], ['Rug', 'G']];
  var OPEN = [['Borst links', 'K'], ['Borst rechts', 'K'], ['Rug', 'G']];

  /* familie van een product, volgt het producttype (zelfde indeling als het personalisatieblok) */
  var LIJF = /^(t-shirts|sportshirts|ondershirts|tunieken|jurken|pyjama's|polo's|hoodies|truien|vesten|jassen|bodywarmers|overhemden|overhemden \/ blouses|labjassen)$/;
  var OPEN_T = /^(jassen|vesten|bodywarmers|overhemden|overhemden \/ blouses|labjassen|polo's)$/;
  function familie(type, titel) {
    var t = String(type || '').toLowerCase().trim(), n = String(titel || '').toLowerCase();
    if (/^(petten|hoeden|bandana hoeden|hoeden en accessoires|beretten|koksmutsen|hoofdbanden)$/.test(t)) return { id: 'pet', soort: 'vorm', lijst: [['Voorkant', 'P']] };
    if (/^(mutsen|bivakmutsen)$/.test(t)) return { id: 'muts', soort: 'vorm', lijst: [['Voorkant', 'P']] };
    /* shoppers (o.a. totebags): ook een klein logo in de hoek linksonder of rechtsonder (28 okt, Wout) */
    if (/^(tassen|shoppers|rugzakken)$/.test(t)) return { id: 'tas', soort: 'vorm', lijst: t === 'rugzakken' ? [['Voorkant', 'M']] : t === 'shoppers' ? [['Voorkant', 'M'], ['Achterkant', 'M'], ['Linksonder', 'K'], ['Rechtsonder', 'K']] : [['Voorkant', 'M'], ['Achterkant', 'M']], breedte: tasBreedte(n, t) };
    if (t === 'schorten') return { id: 'schort', soort: 'vorm', lijst: [['Bovenaan', 'K'], ['Onderaan', 'M']] };
    if (LIJF.test(t) || !t) {
      var open = OPEN_T.test(t) || /rits|vest|zip|jas/.test(n);
      return { id: 'lijf', soort: 'lijf', kap: /capuchon|hood|\bkap\b/.test(n), lijst: open ? OPEN : STANDAARD };
    }
    return null;
  }
  function tasBreedte(n, t) {
    if (/heup/.test(n)) return 30;
    if (/rugzak/.test(n) || t === 'rugzakken') return 30;
    if (/schouder/.test(n)) return 30;
    if (/reistas|duffel|sporttas|weekend/.test(n)) return 50;
    if (/shopper|boodschap/.test(n) || t === 'shoppers') return 40;
    return 38;
  }

  /* vormfamilies: zone (cm) en middelpunt in fracties van het beeld */
  function vormZone(geo, fam, naam, m) {
    var bx = geo.x1 - geo.x0, by = geo.y1 - geo.y0, R = geo.ratio, mc = (geo.x0 + geo.x1) / 2;
    var cmW, px, cxz, cyz, k = 1;
    if (fam.id === 'pet') {
      /* vooraanzicht (symmetrisch) of schuin van voren (klep naar links of rechts): de voorkant ligt
         dan ongeveer in het midden van de omtrek, iets hoger en smaller in beeld */
      var voor = geo.sym > 0.88;
      cmW = voor ? 21 : 27; px = bx / cmW;
      cxz = mc;
      if (voor) cyz = geo.y0 + 0.42 * by;
      else { cyz = geo.y0 + 0.37 * by; k = 0.8; }
      return { px: px, cx: cxz, cy: cyz, cm: [10 * k, 5.5], schuin: !voor, R: 9 };
    }
    if (fam.id === 'muts') {
      cmW = 22; px = bx / cmW;
      /* op de omslag, of waar die zou zitten (onderaan, maar boven een eventuele schaduw) */
      return { px: px, cx: mc, cy: geo.y0 + 0.72 * by, cm: [8, 4.5] };
    }
    if (fam.id === 'tas') {
      cmW = fam.breedte || 38; px = geo.maxW / cmW;
      var top = Math.max(geo.lijfTop, geo.y0);
      if (naam === 'Linksonder' || naam === 'Rechtsonder') {
        /* klein logo in de hoek: 4 cm van de zijkant en van de onderkant */
        var hoogCm = (geo.y1 - top) * R / px, marge = 4;
        var zw = Math.min(m[0], 0.3 * cmW), zh = Math.min(m[1], 0.35 * hoogCm);
        var dxh = (cmW / 2 - marge - zw / 2) * px;
        return { px: px, cx: naam === 'Linksonder' ? mc - dxh : mc + dxh, cy: geo.y1 - (marge + zh / 2) * px / R, cm: [zw, zh] };
      }
      return { px: px, cx: mc, cy: (top + geo.y1) / 2, cm: [Math.min(m[0], 0.6 * cmW), Math.min(m[1], 0.55 * (geo.y1 - top) * R / px)] };
    }
    if (fam.id === 'schort') {
      /* borstschort (smal bovenaan, halslus) of sloof (enkel taille) */
      cmW = 70; px = geo.maxW / cmW;
      var slab = geo.bW12 < 0.6 * geo.maxW;
      if (naam === 'Bovenaan') return { px: px, cx: mc, cy: geo.y0 + (slab ? 0.27 : 0.28) * by, cm: m };
      return { px: px, cx: mc, cy: geo.y0 + (slab ? 0.7 : 0.66) * by, cm: m };
    }
    return null;
  }

  /* rechthoeken in fracties van beeldbreedte (x, w) en -hoogte (y, h).
     corr = per product: { _groep: 'dames', 'Borst links': { dx: cm, dy: cm, s: factor } }
     fam = familie(type, titel); zonder fam = lijf */
  function zones(geo, titel, kant, corr, lijst, fam) {
    if (!geo) return [];
    corr = corr || {};
    fam = fam || { id: 'lijf', soort: 'lijf', kap: false, lijst: STANDAARD };
    var out = [];
    if (fam.soort === 'vorm') {
      (lijst || fam.lijst).forEach(function (l) {
        var naam = l[0], z = POS[naam], m = MAAT[l[1]] || MAAT.K;
        if (!z || z[0] !== kant) return;
        var v = vormZone(geo, fam, naam, m);
        if (!v) return;
        var c = corr[naam] || {}, s = c.s || 1;
        /* schuin gefotografeerde pet met een draaihoek: het logo wordt vervormd getekend, dus de zone
           krijgt weer de volle breedte op de stof (de vervorming maakt het in beeld smaller) */
        var w0 = v.schuin && c.yaw ? 10 : v.cm[0];
        var cmW = w0 * s, cmH = v.cm[1] * s;
        var bw = cmW * v.px, bh = cmH * v.px / geo.ratio;
        var x = v.cx + (c.dx || 0) * v.px, y = v.cy + (c.dy || 0) * v.px / geo.ratio - bh / 2;
        out.push({ naam: naam, kant: kant, anker: 'm', x: x - bw / 2, y: y, w: bw, h: bh, cm: [Math.round(cmW * 10) / 10, Math.round(cmH * 10) / 10], px: v.px, ratio: geo.ratio, vorm: true,
          yaw: c.yaw || 0, rot: c.rot || 0, boog: c.boog || 0, R: v.R || 0 });
      });
      return out;
    }
    var gn = GROEP[corr._groep] ? corr._groep : groep(titel);
    var G = GROEP[gn], px = geo.borst / G.lijf; /* fractie beeldbreedte per cm */
    (lijst || fam.lijst || STANDAARD).forEach(function (l) {
      var naam = l[0], z = POS[naam], m = MAAT[l[1]] || MAAT.K;
      if (!z || z[0] !== kant || !/^(Borst|Rug)/.test(naam)) return;
      var c = corr[naam] || {};
      var s = c.s || 1;
      var cmW = Math.min(m[0], 0.7 * G.lijf) * s, cmH = Math.min(m[1], 0.8 * G.lijf) * s;
      var bw = cmW * px, bh = cmH * px / geo.ratio;
      var dy0 = naam === 'Rug' && fam.kap ? RUG_KAP : z[2];
      var x = geo.cx + (z[1] * G.f + (c.dx || 0)) * px;
      var y = geo.hps + (dy0 * G.f + (c.dy || 0)) * px / geo.ratio;
      if (z[3] === 'm') y -= bh / 2;
      out.push({ naam: naam, kant: kant, anker: z[3], x: x - bw / 2, y: y, w: bw, h: bh, cm: [Math.round(cmW * 10) / 10, Math.round(cmH * 10) / 10], px: px, ratio: geo.ratio });
    });
    return out;
  }

  /* logo (lw x lh) zo groot mogelijk in de zone; geeft fracties terug */
  function pas(zone, lw, lh, ratioBeeld) {
    var zw = zone.w, zh = zone.h * ratioBeeld; /* beide in breedte-eenheden */
    var k = Math.min(zw / lw, zh / lh), w = lw * k, h = lh * k / ratioBeeld;
    var x = zone.x + (zone.w - w) / 2;
    var y = zone.anker === 'm' ? zone.y + (zone.h - h) / 2 : zone.y;
    return { x: x, y: y, w: w, h: h };
  }

  /* ---- vervormd tekenen (schuin gefotografeerde petten) ----
     Het logo ligt op een cilinder (straal R) die over yaw graden gedraaid is, en draait in het vlak
     over rot graden. boog = hoe ver de camera boven de pet staat (graden): dan liggen de delen van het
     logo die naar de camera wijzen lager in beeld, zoals de rondung van de pet.
     o = { yaw: graden, rot: graden, boog: graden, R: px }. Werkt in het coordinatenstelsel van x. */
  function vervormFn(bw, o) {
    var yaw = (o.yaw || 0) * Math.PI / 180, R = o.R > 0 ? o.R : bw * 2;
    return {
      X: function (u) { var a = (u - 0.5) * bw / R; var b = yaw + a; if (b > 1.45) b = 1.45; if (b < -1.45) b = -1.45; return R * (Math.sin(b) - Math.sin(yaw)); },
      Y: function (u) { var a = (u - 0.5) * bw / R, b = Math.max(-1.45, Math.min(1.45, yaw + a)); return R * Math.sin((o.boog || 0) * Math.PI / 180) * (Math.cos(b) - Math.cos(yaw)); }
    };
  }
  function vervormd(o) { return !!o && !!(o.yaw || o.rot || o.boog); }
  function vervorm(x, src, bx, by, bw, bh, o) {
    var f = vervormFn(bw, o), N = Math.max(10, Math.min(80, Math.round(bw / 2)));
    var sw0 = src.width / N;
    x.save();
    x.translate(bx + bw / 2, by + bh / 2);
    x.rotate((o.rot || 0) * Math.PI / 180);
    for (var i = 0; i < N; i++) {
      var u0 = i / N, u1 = (i + 1) / N, x0 = f.X(u0), x1 = f.X(u1);
      if (x1 - x0 < 0.02) continue;
      var ym = f.Y((u0 + u1) / 2);
      x.drawImage(src, sw0 * i, 0, sw0 + (i < N - 1 ? 0.5 : 0), src.height, x0, -bh / 2 + ym, x1 - x0 + 0.6, bh);
    }
    x.restore();
  }
  function vervormPad(x, bx, by, bw, bh, o) {
    var f = vervormFn(bw, o), N = 24, i, u;
    x.save();
    x.translate(bx + bw / 2, by + bh / 2);
    x.rotate((o.rot || 0) * Math.PI / 180);
    x.beginPath();
    for (i = 0; i <= N; i++) { u = i / N; if (i) x.lineTo(f.X(u), -bh / 2 + f.Y(u)); else x.moveTo(f.X(u), -bh / 2 + f.Y(u)); }
    for (i = N; i >= 0; i--) { u = i / N; x.lineTo(f.X(u), bh / 2 + f.Y(u)); }
    x.closePath();
    x.restore();
  }

  g.T2YDruk = { meet: meet, goed: goed, zones: zones, pas: pas, vervorm: vervorm, vervormPad: vervormPad, vervormd: vervormd, groep: groep, familie: familie, GROEP: GROEP, MAAT: MAAT, POS: POS, STANDAARD: STANDAARD, OPEN: OPEN };
})(window);
